import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getLeaderBoard = createAsyncThunk("leaderboard/getLeaderBoard", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetLeaderBoard`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});